import CodeMirror from 'codemirror';

CodeMirror.defineMode('go-template', (config) => {
  const baseMode = CodeMirror.getMode(config, 'htmlmixed');
  const goMode = CodeMirror.getMode(config, 'text/x-go');

  return CodeMirror.multiplexingMode(
    baseMode,
    {
      open: '{{',
      close: '}}',
      mode: goMode,
      delimStyle: 'template-delim',
      innerStyle: 'template-inner'
    },
    {
      open: '{{-',
      close: '-}}',
      mode: goMode,
      delimStyle: 'template-delim',
      innerStyle: 'template-inner'
    }
  );
});

CodeMirror.defineMIME('text/x-go-template', 'go-template');
